// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs import
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { classToPlain, plainToClass } from 'class-transformer';

// CC-Common imports
import { Utils } from 'cc-common';

// 3rd party imports
import { AuthService } from '../auth.service';
import { MPCacheRegistrationService } from '../shared-services/mp-cache-registration-service';

// Constants imports
import { CacheDuration } from '../../_constants/cache-duration';
import { URLConstants } from '../../_constants/url-constants';

// models imports
import { QaTesterRawDto } from '../../_models/qa-tester-raw-dto';
import { QaTestersSaveParameterDto } from '../../_models/qa-testers-save-parameter-dto';

@Injectable({
    providedIn: 'root'
})
export class QaUserService {
    private _qaUsers: QaTesterRawDto[] = [];

    constructor(
        private readonly authService: AuthService,
        private readonly httpClient: HttpClient,
        private readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    loadQaUsers(): Observable<boolean> {
        return new Observable((observer) => {
            if (this.authService.isLoggedIn) {
                this.getQaUsers(true).subscribe(() => {
                    observer.next(true);
                    observer.complete();
                });
            } else {
                observer.next(false);
                observer.complete();
            }
        });
    }

    hasQaReleaseAccess(accessCode: string, userId: string): boolean {
        if (Utils.notNullOrEmpty(this._qaUsers) && Utils.notNullOrEmpty(accessCode) && Utils.notNullOrEmpty(userId)) {
            return (
                this._qaUsers.findIndex(
                    (r) =>
                        Utils.equalsIgnoreCase(accessCode, r.moduleCode) && Utils.containsIgnoreCase(r.userIds, userId)
                ) !== -1
            );
        }
        return false;
    }

    getQaUsers(clearCache = false): Observable<QaTesterRawDto[]> {
        const url = URLConstants.ccUserBaseApiUrl + `/betatesters?clearCache=${clearCache}`;
        this.cacheRegistrationService.registerForCache(url, clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient.get(url, options).pipe(
            map((response: any[]) => {
                this._qaUsers = plainToClass(QaTesterRawDto, response);
                return this._qaUsers;
            })
        );
    }

    saveQaMembers(params: QaTestersSaveParameterDto): Observable<any> {
        const url = URLConstants.ccUserBaseApiUrl + `/betatesters`;
        return this.httpClient.post(url, classToPlain(params));
    }
}
